import {  createSlice } from '@reduxjs/toolkit';
import { RootState } from '../../app/store';
import { UserExtraReducer } from './userThunk';


export interface UserState {
  loadStatus: 'idle' | 'loading' | 'failed' | 'success',
  submitStatus: 'idle' | 'submitting' | 'failed' | 'success',
  dataSource: any,
  columns: any,
  total?: number,
}

const initialState: UserState = {
  loadStatus: 'loading',
  submitStatus: 'idle',
  dataSource: [],
  columns: [],
  total: 0,
};


export const deviceSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    
  },
  extraReducers: UserExtraReducer,
});

// export const { } = deviceTypeSlice.actions;

export const selectloadStatus = (state: RootState) => state.user.loadStatus;
export const selectSubmitStatus = (state: RootState) => state.user.submitStatus;
export const selectDataSource = (state: RootState) => state.user.dataSource;
export const selectColumns = (state: RootState) => state.user.columns;
export const selectTotal = (state: RootState) => state.user.total;

export default deviceSlice.reducer;
